import { Book } from '../../../rest/models';
import { useAppDispatch } from '../../../store/hooks';
import { bookEditorActions } from './slice';
import { BookEditExplanations } from './explanation';
import { Input } from '../../RequestRespectingInputs';

/**
 * Settings only necessary if we're using the rich text editor.
 */
export function BookRichTextOptionsEdit(props: Props)
{
    const appDispatch = useAppDispatch();
    
    return (
    <fieldset>
        <legend>Additional settings for the rich text editor</legend>

        <p>
            If you use the rich text editor, its input is HTML. The book will have a hierarchical structure,
            like HTML does.
        </p>

        <label htmlFor='non_text_elements'>
            Non Text Elements
        </label>
        <div children={BookEditExplanations.non_text_elements}/>
        <Input
            id='non_text_elements'
            value={props.formBook.non_text_elements}
            onChange={(e) => appDispatch(bookEditorActions.setNonTextElements(e.target.value))}/>
        <br/><br/>

        <label htmlFor='skipped_elements'>
            Skipped Elements
        </label>
        <div children={BookEditExplanations.skipped_elements}/>
        <Input
            id='skipped_elements'
            value={props.formBook.skipped_elements}
            onChange={(e) => appDispatch(bookEditorActions.setSkippedElements(e.target.value))}/>
    </fieldset>)
}

interface Props
{
    formBook: Book;
}